/**
 * boot-extras.js
 *
 * Non-critical UI modules loaded after the main bundle.
 * Includes Gallery, Wiki, Sharing, and other "app" features.
 */

import { isFeatureEnabled } from './utils/featureFlags.js';
import * as DebugModule from './utils/debug.js';
const Debug = DebugModule.default || DebugModule;

// Gallery-related imports - only load if feature is enabled
if (isFeatureEnabled('gallery')) {
  (async function loadGallery() {
    await import('../ui/wiki-db.js');
    await import('../legacy/wiki-sync.js');
    await import('../ui/components/gallery/gallery-embed.js');
    await import('../ui/gallery.js');

    // Initialize WikiSync to populate IndexedDB cache for instant gallery loading
    // Only syncs once on page load (in background), no periodic refresh needed
    if (window.WikiSync && window.WikiDB) {
      try {
        const wikiDB = new window.WikiDB();
        await wikiDB.init();
        window.wikiDB = wikiDB; // Make available globally

        const sync = new window.WikiSync(wikiDB);
        sync.syncIfNeeded(); // Background sync - don't await, let page load continue
        Debug.log('loader', 'WikiSync initialized');
      } catch (e) {
        Debug.warn('loader', 'WikiSync init failed:', e);
      }
    }
  })();
}

import '../ui/category-icons.js';
import '../ui/instacalc-data.js';
import '../ui/instacalc-bridge.js';
import '../ui/theme/switcher.js';
import '../ui/wip/bg-playground.js';
import '../ui/sharing-ux.js';

Debug.log('loader', 'Extras loaded');
